export default {
    install(Vue) {
        Vue.auth = {
            isAuthenticated() {
                return !!this.getToken();
            },

            setToken(token, expiration) {
                localStorage.setItem('ludum_token', JSON.stringify(token));
                Vue.cookie.set('ludum_token', token.access_token, { expires: expiration });
            },

            getToken() {
                let token = localStorage.getItem('ludum_token');
                return token ? JSON.parse(token).access_token : false;
            },

            hasExpired() {
                let token = this.getToken();
                return token ? new Date(token.expires_in * 1000) < Date.now() : true;
            },

            refreshToken() {
                let token = localStorage.getItem('ludum_token');
                return token ? JSON.parse(token).refresh_token : false;
            },

            destroyToken() {
                localStorage.removeItem('ludum_token');
                Vue.cookie.delete('ludum_token');
            }
        };

        Vue.prototype.$auth = function() {
            return Vue.auth;
        };
    }
};
